import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaPinterest, FaFacebook, FaEnvelope } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <h3 className="footer-logo">Safarnamah</h3>
            <p className="footer-tagline">By Saket and Pallavi</p>
            <p className="footer-description">
              Curated travel guides and stories for the inquisitive world explorer. 
              Discover hidden gems, cultural insights, and authentic experiences across Asia.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>Explore</h4>
              <ul>
                <li><Link to="/places">Places</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/plan-trip">Plan Your Trip</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Destinations</h4>
              <ul>
                <li><Link to="/places/dubai">Dubai</Link></li>
                <li><Link to="/places/thailand">Thailand</Link></li>
                <li><Link to="/places/vietnam">Vietnam</Link></li>
                <li><Link to="/places/sri-lanka">Sri Lanka</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Connect</h4>
              <div className="footer-social">
                <a href="https://www.instagram.com/safarnamah_/#" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <FaInstagram />
                </a>
                <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer" aria-label="Pinterest">
                  <FaPinterest />
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <FaFacebook />
                </a>
                <a href="mailto:contact@safarnamah.in" aria-label="Email">
                  <FaEnvelope />
                </a>
              </div>
              <p className="footer-email">contact@safarnamah.in</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Safarnamah. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <span>•</span>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
